import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { ActionButtonStyled, MessageStyled, TileStyled } from './styles';

interface Props extends ICustomizableElement {
  icon: React.ReactNode;
  actionName: string;
  action: () => void;
  message: string;
  dataTestId?: string;
}

const ActionTile: React.FC<Props> = ({ icon, actionName, action, message, dataTestId, className }) => {
  return (
    <TileStyled onClick={action} role="button" data-test-id={dataTestId} className={className}>
      {icon}
      <ActionButtonStyled>{actionName}</ActionButtonStyled>
      <MessageStyled>{message}</MessageStyled>
    </TileStyled>
  );
};

export default ActionTile;
